const STEP_PX = 0.5;

/**
 * Returns the font size at which `label` fits on one line within `availableWidth`.
 * The usual size is kept when it already fits; otherwise the largest half-pixel step
 * below it that fits is returned, down to 0.5 (there is no floor: a label is never cut).
 */
export function fitLabelFontSize(
  label: string,
  availableWidth: number,
  measure: (text: string, sizePx: number) => number,
  usualSizePx = 18
): number {
  if (measure(label, usualSizePx) <= availableWidth) {
    return usualSizePx;
  }

  for (let size = usualSizePx - STEP_PX; size > STEP_PX; size -= STEP_PX) {
    if (measure(label, size) <= availableWidth) {
      return size;
    }
  }

  return STEP_PX;
}
